import Reveal from "@/components/Reveal";
import SectionEyebrow from "@/components/SectionEyebrow";
import Seo from "@/components/Seo";

// Reusable premium legal-page layout.
// sections: [{ heading?: string, body?: string | string[], list?: string[] }]
export default function LegalPage({ eyebrow, title, updated, intro, sections, seoTitle, seoDescription, testId }) {
    return (
        <div data-testid={testId} className="relative">
            <Seo title={seoTitle} description={seoDescription} />

            <section className="mx-auto max-w-4xl px-6 pt-20 pb-8 lg:px-10">
                <Reveal>
                    <SectionEyebrow>{eyebrow}</SectionEyebrow>
                </Reveal>
                <Reveal delay={0.1}>
                    <h1 className="mt-6 font-display text-4xl font-semibold leading-[1.05] tracking-tighter sm:text-5xl lg:text-6xl">
                        {title}
                    </h1>
                </Reveal>
                {updated && (
                    <Reveal delay={0.15}>
                        <p className="mt-5 text-xs uppercase tracking-[0.24em] text-white/45">
                            Last updated: {updated}
                        </p>
                    </Reveal>
                )}
                {intro && (
                    <Reveal delay={0.2}>
                        <p className="mt-6 text-base leading-relaxed text-white/65 md:text-lg">
                            {intro}
                        </p>
                    </Reveal>
                )}
            </section>

            <section className="mx-auto max-w-4xl px-6 pb-24 lg:px-10">
                <Reveal>
                    <div className="glass glow-border rounded-lg p-8 md:p-12">
                        <div className="space-y-10">
                            {sections.map((s, i) => (
                                <div key={i} data-testid={`legal-section-${i}`}>
                                    {s.heading && (
                                        <h2 className="font-display text-xl font-medium text-white md:text-2xl">
                                            <span className="gold-text">
                                                {String(i + 1).padStart(2, "0")}.
                                            </span>{" "}
                                            {s.heading}
                                        </h2>
                                    )}
                                    {s.body &&
                                        (Array.isArray(s.body) ? s.body : [s.body]).map(
                                            (p, j) => (
                                                <p
                                                    key={j}
                                                    className="mt-4 text-sm leading-relaxed text-white/70 md:text-base"
                                                >
                                                    {p}
                                                </p>
                                            ),
                                        )}
                                    {s.list && (
                                        <ul className="mt-4 space-y-2.5">
                                            {s.list.map((li, k) => (
                                                <li
                                                    key={k}
                                                    className="flex items-start gap-3 text-sm leading-relaxed text-white/70 md:text-base"
                                                >
                                                    <span className="mt-2 h-1.5 w-1.5 flex-none rounded-full bg-gold-300" />
                                                    <span>{li}</span>
                                                </li>
                                            ))}
                                        </ul>
                                    )}
                                </div>
                            ))}
                        </div>
                    </div>
                </Reveal>
            </section>
        </div>
    );
}
